import { Stack, useTheme } from "@mui/material";
import { CompanyOverview } from "src/api/client-api/company/overview/useOrganizationOverview";
import { DiagnosticOverview } from "./Diagnostic/DiagnosticOverview";
import { ScoresOverview } from "./Scores/ScoresOverview";
import { StrategyOverview } from "./Strategy/StrategyOverview";
import { MyPublications } from "src/components/Publications/MyPublications";
import { ExtensionPoint, EXTENSION_POINTS } from "src/components/PuckExtensions";

type OverviewProps = {
    overview: CompanyOverview | undefined;
};
export const Overview = (props: OverviewProps) => {
    const { overview } = props;
    const theme = useTheme();

    const ssqs = overview?.ssqs;
    const scoresOverview = overview?.scores;

    return (
        <Stack gap={{ xs: theme.spacing(2), lg: theme.spacing(3) }}>
            <ExtensionPoint extensionPoint={EXTENSION_POINTS.COMPANY_OVERVIEW_BANNER} />
            {ssqs !== undefined && <DiagnosticOverview ssqs={ssqs} />}
            {scoresOverview !== undefined && <ScoresOverview scoresOverview={scoresOverview} ssqs={ssqs ?? []} />}
            <MyPublications />
            {overview !== undefined && <StrategyOverview overview={overview} />}
        </Stack>
    );
};
